import type { STUser, UserJoint } from "@stss/types";
import classNames from "classnames";
import Link from "next/link";
import React from "react";

import NotProvided from "./NotProvided";

export const MemberCard = ({
  member,
  programs,
  onActivate,
}: {
  member: STUser;
  programs: UserJoint[];
  onActivate: (id: UserJoint["id"]) => void;
}) => {
  return (
    <div className="border-subtle bg-muted overflow-hidden shadow sm:rounded-lg">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg font-medium leading-6">
          {member.first_name || member.last_name ? (
            `${member.first_name} ${member.last_name}`
          ) : (
            <NotProvided text="User name is not provided" />
          )}
        </h3>
      </div>
      <div className="">
        <dl>
          <div className="border-subtle border-t px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium">Email:</dt>
            <dd className="mt-1 text-sm sm:col-span-2">{member.email || <NotProvided />}</dd>
          </div>
          <div className="border-subtle border-t px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium">Birth date:</dt>
            <dd className="mt-1 text-sm sm:col-span-2">{member.birthdate || <NotProvided />}</dd>
          </div>
          <div className="border-subtle border-t px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium">Gender:</dt>
            <dd className="mt-1 text-sm sm:col-span-2">{member.gender || <NotProvided />}</dd>
          </div>
          <div className="border-subtle border-t px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium">Residence state:</dt>
            <dd className="mt-1 text-sm sm:col-span-2">
              <ul role="list" className="divide-subtle divide-y">
                <li className="grid grid-cols-2 py-2">
                  <span>ID:</span>
                  <span>{member.residence_state_id || <NotProvided />}</span>
                </li>
                <li className="grid grid-cols-2 py-2">
                  <span>State:</span>
                  <span>{member.residence_state || <NotProvided />}</span>
                </li>
                <li className="grid grid-cols-2 py-2">
                  <span>Name:</span>
                  <span>{member.residence_state_name || <NotProvided />}</span>
                </li>
              </ul>
            </dd>
          </div>
          {/* // member programs */}
          <div>
            <div className="border-subtle border-t px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium">Programs:</dt>
              <dd className="mt-1 text-sm sm:col-span-2">
                <ul role="list" className="group">
                  <li className="grid grid-cols-4 pb-2 font-bold">
                    <span>Name:</span>
                    <span className="col-span-2">Status:</span>
                    {/* <span>Progress:</span> */}
                    <span className="text-right">Override:</span>
                  </li>
                  {programs.map((joint) => {
                    return (
                      <li
                        key={joint.id}
                        className={classNames("border-subtle group grid h-10 grid-cols-4 border-t")}>
                        <span className="flex h-full w-full items-center">{joint.name}</span>
                        <span className="flex h-full w-full items-center text-green-500 dark:text-green-600">
                          {joint.statusDisplayName}
                        </span>
                        <p className="ml-1 flex h-full w-full items-center text-center">
                          {joint.session_in_progress ? (
                            <span className="">(in progress)</span>
                          ) : (
                            <span className="text-gray-500">(not in progress)</span>
                          )}
                        </p>
                        <span className="flex h-full w-full items-center justify-end">
                          {joint.override_id ? (
                            <Link
                              href={"/manual-override/" + joint.override_id}
                              title="See override details"
                              className="ml-1 text-sky-500 underline dark:text-sky-600">
                              {joint.override_id}
                            </Link>
                          ) : (
                            <button
                              title={`Activate override for ${joint.name}`}
                              className="text-muted hover:text-default border-none p-0 underline"
                              onClick={() => onActivate(joint.id)}>
                              activate override
                            </button>
                          )}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </dd>
            </div>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default MemberCard;
